import { cn } from "@portal/ui";
import { Hint } from "./Hint";
import { useId, type ComponentProps, type ReactNode } from "react";

/**
 * ホームの区切り。カードの枠(罫線の箱)は使わず、見出しの下線と余白で区切る(ユーザー要望 2026-10-07)。
 * 見出しの右に操作(ボタンなど)を置ける。section の名前は見出しから付ける。
 * 説明は見出しの右のヒント(?)に入れる(画面に文章を書かない。ユーザー要望 2026-10-15)。
 */
export function HomeSection({
  title,
  description,
  action,
  className,
  children,
  ...props
}: {
  title: ReactNode;
  /** 区切りの説明。見出しの右のヒントに出す。 */
  description?: string;
  /** 見出しの右に置く操作。 */
  action?: ReactNode;
} & Omit<ComponentProps<"section">, "title">) {
  const id = useId();
  return (
    <section
      aria-labelledby={id}
      className={cn("flex min-w-0 flex-col gap-3", className)}
      {...props}
    >
      {/* header 要素は使わない(アプリ全体のヘッダー=ナビゲーションバーと紛らわしくなるため) */}
      <div
        data-slot="home-section-header"
        className="flex items-end justify-between gap-3 border-b pb-2"
      >
        <div className="flex min-w-0 items-center gap-1.5">
          <h2 id={id} className="text-base font-semibold">
            {title}
          </h2>
          {description && (
            <Hint label={`${typeof title === "string" ? title : "この欄"}の説明`}>
              {description}
            </Hint>
          )}
        </div>
        {action && <div className="shrink-0">{action}</div>}
      </div>
      {children}
    </section>
  );
}
